/**
 * Standalone "Thank You" page rendered when the URL is /thank-you.
 * Has its own logo, large title, confirmation copy and sign-off.
 * The user goes back to the form via the browser's back button.
 */
export function ThankYou() {
  return (
    <section className="panel panel--parchment" id="thanks">
      <div className="parchment-frame parchment-frame--centered">
        <div className="thanks">
          <img className="thanks__logo" src="/logo.png" alt="Valéo" draggable={false} />
          <h2 className="thanks__title">Thank you</h2>
          <p className="thanks__lede">
            We have received your request and will contact you in the upcoming days.
          </p>
          <p className="thanks__sign">Hasta luego</p>
        </div>
      </div>
    </section>
  );
}
